module.exports = __webpack_public_path__ + "img/originality-design.b03cdc4a.png";